






import { Component, Vue, Watch } from 'vue-property-decorator';
import UserTable from '@/components/user/UserTable.vue';
import TopBar from '@/components/menu/TopBar.vue';
import { User } from '@/models/user.interface';
import { Getter, Action } from 'vuex-class';
import { PaginatedPayload } from '@/models/util.interface';

@Component({
  components: {
    UserTable,
    TopBar,
  },
})
export default class UserList extends Vue {
  @Getter public users!: User[];
  @Action('getUsersAction') public getUsersAction!: (payload?: PaginatedPayload) => void;
  @Action('changeUserPageAction') public changeUserPageAction!: (id: number) => void;
  @Getter private userPage!: number;

  public fetchUsers(): void {
    this.getUsersAction({page: this.userPage});
  }

  public onRemoveUser(id: string): void {
    if (this.users.length === 0 && this.userPage > 1) {
      this.changeUserPageAction(this.userPage - 1);
    } else {
      this.fetchUsers();
    }
    this.$notify({text: `Utilisateur supprimé avec succès`, type: 'success'});
  }

  private mounted() {
    this.userPage !== 1 ? this.changeUserPageAction(1) : this.getUsersAction();
  }

  @Watch('userPage')
  private onUserPaginationChanged(value: number, oldValue: number): void {
    this.fetchUsers();
  }
}
